export function transactionPageUrl(transactionId: string): string {
  return `${window.location.origin}/${transactionId}`;
}
